export default "__VITE_ASSET__2e62f5f1__"